import ServicePageTemplate from "@/components/ServicePageTemplate";

const LTL = () => (
  <ServicePageTemplate
    seoTitle="LTL Freight Shipping | Varstar Alliance"
    seoDesc="Affordable LTL shipping from a single pallet to half a truck. Competitive rates, real-time tracking, and one invoice."
    canonical="/services/ltl"
    h1="Ship smarter. Not bigger."
    subtitle="Not every shipment needs a full truck. Get the space you need at a rate that makes sense."
    ctaText="Get an LTL Quote"
    body={"LTL shipping lets you move smaller freight - from a single pallet to half a truck - without paying for space you don't use. We work with top LTL carriers to find the best combination of price, transit time, and service level."}
    benefits={[
      "Competitive LTL rates from national + regional carriers",
      "Consolidated billing - one invoice regardless of carrier",
      "Real-time tracking and proactive delivery updates",
      "Freight class optimization to keep costs down",
      "Liftgate, inside delivery, and residential options available",
    ]}
  />
);

export default LTL;
